import { motion } from "framer-motion";
import { Server, ShieldCheck, AlertTriangle, Plug } from "lucide-react";
import type { VpsPrecheckEvent } from "../../lib/types";

export function VpsPrecheckBanner({ state }: { state: VpsPrecheckEvent }) {
  if (state.status === "ok") {
    return (
      <motion.div
        initial={{ opacity: 0, y: -4 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.18 }}
        className="card px-4 py-2 flex items-center gap-2 text-small text-fg-muted"
      >
        <ShieldCheck className="size-4 text-success" />
        <span>
          VPS подключен:{" "}
          <span className="font-mono text-fg">
            {state.user ?? "—"}@{state.host ?? "—"}
          </span>
        </span>
      </motion.div>
    );
  }
  if (state.status === "missing") {
    return (
      <motion.div
        initial={{ opacity: 0, y: -4 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.18 }}
        className="glass rounded-card p-4 flex items-start gap-3 border border-warning/40"
      >
        <Server className="size-5 mt-0.5 text-warning shrink-0" />
        <div className="flex-1 space-y-2">
          <div className="font-semibold text-fg">Нужно подключение к серверу</div>
          {state.reason && (
            <p className="text-small text-fg-muted">{state.reason}</p>
          )}
          {state.suggested_action && (
            <p className="text-small text-fg-muted">{state.suggested_action}</p>
          )}
          <button className="btn-primary mt-2" type="button">
            <Plug className="size-4" />
            Открыть VPS-панель
          </button>
        </div>
      </motion.div>
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18 }}
      className="card p-3 flex items-center gap-2 text-small text-warning border-warning/40"
    >
      <AlertTriangle className="size-4" />
      <span>VPS-сессия потеряна. Переподключитесь, чтобы продолжить.</span>
    </motion.div>
  );
}
